import SettingsMamorioSpot from './SettingsMamorioSpot'

export default SettingsMamorioSpot
